import { createI18n } from 'vue-i18n'

import type { TenantLocale } from '@/config/app/types'

import messages from './modules'

/**
 * Правила склонения для русского языка: выбирают одну из форм
 * one / few / many (например, «символ / символа / символов»).
 * Если задано только две формы, используется упрощённый выбор
 * единственное/множественное число.
 */
const pluralRules = {
  ru: (choice: number, choicesLength: number) => {
    if (choicesLength === 2) {
      return choice === 1 ? 0 : 1
    }

    const teen = choice % 100 > 10 && choice % 100 < 20
    const lastDigit = choice % 10

    if (!teen && lastDigit === 1) {
      return 0
    }

    if (!teen && lastDigit >= 2 && lastDigit <= 4) {
      return 1
    }

    return 2
  },
}

/**
 * Создает экземпляр i18n с учетом конфигурации локалей
 * @param locales - массив доступных локалей из конфигурации тенанта
 * @param defaultLocale - локаль по умолчанию
 */
export function createAppI18n(locales: TenantLocale[], defaultLocale: string) {
  // Фильтруем сообщения, оставляя только доступные локали
  const availableLocaleCodes = locales.map((l) => l.code)
  const filteredMessages = Object.keys(messages)
    .filter((key) => availableLocaleCodes.includes(key))
    .reduce(
      (obj, key) => {
        obj[key as keyof typeof messages] = messages[key as keyof typeof messages]
        return obj
      },
      {} as typeof messages,
    )

  return createI18n({
    fallbackLocale: 'en',
    locale: defaultLocale,
    legacy: false,
    globalInjection: true,
    messages: filteredMessages,
    pluralRules,
  })
}

// Экспорт по умолчанию для обратной совместимости (можно удалить позже)
export default createI18n({
  fallbackLocale: 'en',
  locale: 'ru',
  legacy: false,
  globalInjection: true,
  messages,
  pluralRules,
})
